module.exports = __webpack_public_path__ + "img/money-1.3fc38225.png";